"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEditorialListStencil = exports.editorialListStencilDefinition = void 0;
const properties_1 = require("../properties");
const type_of_editorial_list_property_1 = require("../properties/type-of-editorial-list.property");
exports.editorialListStencilDefinition = {
    view: {
        label: 'Editorial list',
        group: 'Collections',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'type-of-editorial-list',
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'preferred-label',
                            'featured-media',
                            'featured-video',
                            'logos',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        'cta-container': {
            ...properties_1.ctaContainerPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: ['cta-asset'],
                },
            ],
        },
        disciplines: properties_1.disciplinesPropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'featured-video': properties_1.featuredVideoPropertyDefinition,
        'header-media': properties_1.headerMediaPropertyDefinition,
        logos: properties_1.logosPropertyDefinition,
        'preferred-label': properties_1.preferredLabelPropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        standalone: properties_1.standalonePropertyDefinition,
        subheading: properties_1.subheadingPropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        'type-of-editorial-list': type_of_editorial_list_property_1.typeOfEditorialListPropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'global',
        'illume',
        'media-partnerships',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'xalps',
    ],
    name: 'editorial-list',
};
const isEditorialListStencil = (stencil) => {
    return stencil.name === exports.editorialListStencilDefinition.name;
};
exports.isEditorialListStencil = isEditorialListStencil;
//# sourceMappingURL=data:application/json;base64,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